var {AmpersandState} = require('catalog/libs');
var HPELog = require('core/log');

var HPEServices = require('./hpe.services');
var HPEConstants = require('./hpe.constants');

/**
 * selector router
 */
module.exports = AmpersandState.extend({

    /**
     * initialization
     */
    initialize: function() {

        //event handlers
        HPEServices.subscribe(HPEConstants.router.ROUTER_UPDATE_PAGE, this, this.onPageUpdate);
        window.addEventListener('load', this.onWindowLoad.bind(this));
    },

    /**
     * properties
     */
    props: {
        page: 'string',
        state: 'object'
    },

    /**
     * handle window load event
     */
    onWindowLoad: function() {

        var that = this;

        //add popstate event listener on window load to get around safari/ios/older webkit bug
        //where popstate is fired on page load
        setTimeout(function() {
            window.addEventListener('popstate', that.onBrowserPopState.bind(that));
        }, 0);
    },

    /**
     * handle browser pop state event
     * @param {object} e popstate event object
     */
    onBrowserPopState: function(e) {

        //get a page value (if exists) and publish page change event with that value
        this.page = this.getPageValue();
        this.state = e.state || {};
        this.publishPageChangeEvent();
    },

    /**
     * handle event request to update the page string
     * @param {object} payload with required page key/value pair and optional state object
     */
    onPageUpdate: function(payload) {
        if (payload.page) {

            this.page = payload.page;
            this.state = payload.state || {};

            window.history.pushState(this.state, null, this.page);

            this.publishPageChangeEvent();
        } else {
            // Warn Message
            HPELog.debug('Page router update event missing require page parameter');
        }
    },

    /**
     * broadcast a page change event with object parameter
     * containing current page and optional state
     */
    publishPageChangeEvent: function() {
        HPEServices.publish(HPEConstants.router.BROWSER_PAGE_CHANGE, {
            page: this.page,
            state: this.state
        });
    },

    /**
     * retrieve the current page value in URL
     * @return {string} page value
     */
    getPageValue: function() {

        //TODO: sanitize this
        var pathname = window.location.pathname;
        return (pathname) ? pathname.split('/').pop() : '';
    }
});
